<template>
    <vx-modal :visible="isVisible" @update:visible="selectedResource = undefined" size="md" :padding="false">
        <resource-detail :resource="resource" :category="props.category" />

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button @click="selectedResource = undefined" type="button" class="grow" size="lg">
                    Close
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import ResourceDetail from './ResourceDetail.vue';
import { analyticsCategoriesValues } from '~/constants/categories';
import { computed, watch } from 'vue';
import { useResourcesDetails } from '~/components/analytics/useResourcesDetails';
import { catchRequestError } from '~/utils/request';
import axios from 'axios';
import { useToasted } from '~/composables/useToasted';

const selectedResource = defineModel({
    type: Object,
    required: false,
});

const teamId = Spark.state.currentTeam.id;
const { fetchResourceDetails } = useResourcesDetails();
const toasted = useToasted();

const props = defineProps({
    resource: {
        type: Object,
        required: false,
    },
    category: {
        type: String,
        required: false,
        validator: (category) => analyticsCategoriesValues.includes(category),
    },
});

const isVisible = computed(
    () =>
        selectedResource.value?.resource_id === props.resource.resource_id &&
        selectedResource.value?.resource_type === props.resource.resource_type
);

watch(selectedResource, () => {
    if (isVisible.value) {
        fetchResourceDetails(teamId, [props.resource]).catch((e) => {
            if (!axios.isCancel(e)) {
                toasted.error(catchRequestError(e));
            }
        });
    }
});
</script>
